export const GET_POSTS_BY_CATEGORY = `
    query GetPostsByCategory($category: String!, $first: Int, $after: String) {
        posts(where: { categoryName: $category }, first: $first, after: $after) {
            nodes {
                databaseId
                title
                uri
                featuredImage {
                  node {
                    mediaDetails {
                      sizes {
                        height
                        width
                        sourceUrl
                      }
                    }
                    sourceUrl
                    title
                  }
                }
                categories {
                    nodes {
                        name
                        slug
                        parentId
                    }
                }
            }
            pageInfo {
                endCursor
                total
            }
        }
    }
`;
